import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    id: "personal-training",
    title: "Personal Training",
    tag: "Signature",
    desc: "In-person 1-on-1 sessions designed around your body, your schedule, your goals. Coach Manny trains alongside you — no guesswork.",
    img: "https://images.pexels.com/photos/35986381/pexels-photo-35986381.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-8 md:row-span-2",
    tall: true,
  },
  {
    id: "private-lessons",
    title: "Private Lessons",
    tag: "1 : 1",
    desc: "Focused technique work and form coaching.",
    img: "/images/youth-squat.jpg",
    span: "md:col-span-4",
  },
  {
    id: "soccer-coach",
    title: "Soccer Coaching",
    tag: "Youth + Adult",
    desc: "Ball mastery, speed and confidence — drills that translate to the pitch.",
    img: "https://images.pexels.com/photos/9438093/pexels-photo-9438093.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-4",
  },
  {
    id: "online-classes",
    title: "Online Classes",
    tag: "Anywhere",
    desc: "Structured remote programming and live video coaching that fits your crazy schedule.",
    img: "https://static.prod-images.emergentagent.com/jobs/0a4872c7-0ac7-41c4-a84c-97ee9bda904d/images/93d4e2e41db2f799ab3dc800d6d36c81b5eeb148e880caaa43e66b1301f27a6f.png",
    span: "md:col-span-8",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="section">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#FF3B30] mb-4">
              / 01 — What we coach
            </div>
            <h2
              data-testid="services-title"
              className="font-display text-5xl md:text-7xl uppercase tracking-tight leading-[0.9]"
            >
              Programs built
              <br />
              for real results.
            </h2>
          </div>
          <p className="text-white/60 max-w-md md:text-right">
            Every program is personalised. No cookie-cutter PDFs, no ego
            workouts. Just purposeful training that moves the needle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 md:grid-rows-2 gap-4 md:gap-6">
          {SERVICES.map((s) => (
            <a
              key={s.id}
              href="#book"
              data-testid={`service-${s.id}`}
              className={`tile group ${s.span} min-h-[280px] ${
                s.tall ? "md:min-h-[620px]" : "md:min-h-[300px]"
              } flex flex-col justify-end p-8`}
            >
              <img
                src={s.img}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover tile-img"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/10" />

              <div className="relative z-10 flex items-start justify-between">
                <span className="text-[10px] tracking-[0.3em] uppercase border border-white/20 px-2 py-1 text-white/80 bg-black/40 backdrop-blur-sm">
                  {s.tag}
                </span>
                <div className="w-10 h-10 border border-white/20 flex items-center justify-center group-hover:bg-[#FF3B30] group-hover:border-[#FF3B30] transition">
                  <ArrowUpRight size={16} />
                </div>
              </div>

              <div className="relative z-10 mt-auto pt-10">
                <h3 className="font-display text-3xl md:text-5xl uppercase leading-none">
                  {s.title}
                </h3>
                <p className="text-sm md:text-base text-white/70 max-w-md mt-3">
                  {s.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
